define('SageDotCom/DataLayer/Events/CustomerSuccess/filterPaneEvent',[
    'SageDotCom/DataLayer/Events/eventBase'
], function (EventBase) {

    function FilterPaneEvent(eventName, isOpening, fromQuerystring, element) {
        EventBase.call(this);
        var label = isOpening ? "Filter Open" : "Filter Close";
        var id = fromQuerystring ? document.referrer : element.id;
        var cssClass = fromQuerystring ? '(not set)' : element.className;
        this.props = {
            'event_name': eventName,
            'event_non-int': '0',
            'event_category': 'component',
            'event_action': 'button_click',
            'event_label': label,
            'event_name_level_1': id,
            'event_name_level_2': '(not set)',
            'event_name_level_3': cssClass,
            'event_name_level_4': 'body',
            'destination_url': '(not set)',
            'element_text': label,
            'element_class': cssClass,
            'element_id': id,
            'element_location': 'body'
        };
    }

    FilterPaneEvent.prototype = Object.create(EventBase.prototype);
    
    return FilterPaneEvent;
});
